<template>
	<section>
	
    <header>
      <mo-pageheader>
        <template slot="title">Mon stock</template>
      </mo-pageheader>
    </header>	
	
        <main class="main-layout">
        <!-- TAB SECTION -->

<!--        <div class="tabs-ctn flex flex-center">
          <div
            v-if="accessInfoGeneral"
            class="tab"
            :class="stateFicheArticle == 'general' ? 'active': ''"
            @click="stateFicheArticle = 'Stock'"
            >{{ $t('action.search') }}
          </div>
          <div
            v-if="accessStatistique"
            class="tab"
            :class="stateFicheArticle == 'statistique' ? 'active': ''"
            @click="stateFicheArticle = 'statistique'"
            >{{ $t('sectionTitle.historyOfImports') }}
          </div>
          <div v-if="importCSV && accessImportCsv"
            class="tab"
            :class="stateFicheArticle == 'importcsv' ? 'active': ''"
            @click="stateFicheArticle = 'importcsv'"
            >{{ $t('sectionTitle.importcsv') }}
          </div>
        </div>-->
        
           <stockgeneral v-if="stateFicheArticle == 'Stock'"></stockgeneral>
           <stockstatistique v-if="stateFicheArticle == 'statistique'"></stockstatistique>
           <stockimportcsv v-if="stateFicheArticle == 'importcsv'"></stockimportcsv>
    
		</main>
	</section>
</template>
<script>

import { mapState } from 'vuex';
import Paginate from 'vuejs-paginate';
import { AbIcon, BaButton, BaCard, BaDropdown, BaInput, BaSearch, BaSearchCard, BaSelect, BaStateLabel, BaTable } from '@ab/basic-components';
import MoLoader from '@/components/loader/mo-loader.vue';
import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';
import MoSpeedometer from '@/components/tool/mo-speedometer.vue';

import paginationMixin from '@/components/mixins/pagination.js';
import requestMixin from '@/components/mixins/request.js';
import searchMixin from '@/components/mixins/search.js';
import sortableMixin from '@/components/mixins/sortable.js';

import stockgeneral from './StockList.vue';
import stockstatistique from './Stock-statistique.vue';
import stockimportcsv from './Stock-importcsv.vue';

export default {
  name: 'Stock',
  components: {
    AbIcon,
    BaButton,
    BaCard,
    BaDropdown,
    BaInput,
    BaSearch,
    BaSearchCard,
    BaSelect,
    BaStateLabel,
    BaTable,
    MoLoader,
    MoPageheader,
    MoSpeedometer,
    Paginate,
    stockgeneral,
    stockstatistique,
    stockimportcsv
    
  },
  data() {
    return {
        stateFicheArticle:'Stock',
        importCSV:true,
        accessInfoGeneral: true,
        accessStatistique: true,
        accessImportCsv: true,        
    };
  },
  computed: {
   
  },
  methods: {

  }  
};
</script>
<style src="@/assets/styles/tabs.css"></style>